export default {
  scene: {
    background: 0xffbc8d,
    shadow: 0xee9559,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 1000
    }
  },
  environment: {
    path: '/models/environments/hospital.glb',
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5.1,
      z: 0
    }
  },
  entrance: {
    open: 18,
    close: 54,
    objects: [
      {
        name: 'EntranceDoorLeft',
        open: {
          x: 9,
          y: 0,
          z: 0
        },
        closed: {
          x: 0,
          y: 0,
          z: 0
        }
      },
      {
        name: 'EntranceDoorRight',
        open: {
          x: -9,
          y: 0,
          z: 0
        },
        closed: {
          x: 0,
          y: 0,
          z: 0
        }
      }
    ]
  },
  character: {
    path: '/models/characters/wouter/animated.glb',
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -5,
      y: -5,
      z: 8
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -6,
      y: -5,
      z: 2
    }
  },
  speed: 3
}
